import { FaArrowDown , FaSpinner} from 'react-icons/fa';
import classes from './down-blue-button.module.css';
import { ButtonProps } from '../../../utils/helper-interfaces';
import { useNavigation } from 'react-router-dom';
const DownBlueButton:React.FC<ButtonProps > = (props) => {

  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";
  return (
    <button
      className={classes['button']}
      type={props.type??'button'} 
      onClick={props.onClick}
      disabled={props.isDisabled??false}
    >
      {isSubmitting ? (
        // Show loading spinner while submitting
        <FaSpinner className={`${classes.icon} ${classes.spinner}`} />
      ) : (
        // Show arrow icon when not submitting
        <FaArrowDown className={classes.icon} />
      )}
    </button>
  )

}
export default DownBlueButton;